module.exports = __webpack_public_path__ + "img/美妆-4.89d43697.png";